import type { MultilinkStoryblok } from '@/storyblok/component-types-sb'

export function optionalString(value: string | null | undefined): string | undefined {
  return value === null ? undefined : value
}

export interface IAssetImage {
  filename?: string | null
  alt?: string | null
  title?: string | null
  width?: number | null
  height?: number | null
}

export type TAssetImageProps = {
  src: string | undefined
  alt: string | undefined
  title: string | undefined
  width?: number
  height?: number
}

export function toAssetImageProps(asset?: IAssetImage): TAssetImageProps {
  return {
    src: optionalString(asset?.filename),
    alt: optionalString(asset?.alt),
    title: optionalString(asset?.title),
    width: asset?.width ?? undefined,
    height: asset?.height ?? undefined
  }
}

export function toMultilinkHref(link?: MultilinkStoryblok): string {
  return link?.url || link?.cached_url || ''
}

export function toOptionalAnchor(anchor?: string): string | undefined {
  return anchor?.trim() || undefined
}
